import { useEffect, useState } from "react";
import { api, useCategories, useRemote } from "@/lib/api";
import { ProductGrid } from "@/components/ProductCard";
import { HeroSlider } from "@/components/home/HeroSlider";
import { HomePromos } from "@/components/home/HomePromos";
import { Advantages, CategoryShelf, CategoryTiles, PromoBanners, Section } from "@/components/home/HomeSections";

export default function Home() {
  const home = useRemote("/homepage");
  const cats = useCategories() || [];
  const top = cats.filter((c) => !c.parent_path && c.count > 0);
  const byName = (n) => cats.find((c) => c.name.toLowerCase() === n);
  const [featured, setFeatured] = useState(null);

  useEffect(() => {
    api.get("/products", { params: { featured: true, limit: 8 } }).then((r) => setFeatured(r.data.items)).catch(() => setFeatured([]));
  }, []);

  return (
    <div className="bg-white" data-testid="home-page">
      <HeroSlider slides={home === undefined ? [] : home?.slides} />
      <HomePromos />
      <Section eyebrow="Reparti" title="Categorie principali" testid="home-categories"><CategoryTiles cats={top} /></Section>
      <CategoryShelf cat={byName("iphone nuovi")} eyebrow="Novità" title="iPhone nuovi" testid="home-iphone-nuovi" />
      <CategoryShelf cat={byName("iphone usati premium")} eyebrow="Usato premium" title="iPhone usati premium" testid="home-iphone-usati" />
      <CategoryShelf cat={byName("cloud free premium")} eyebrow="Sezione dedicata" title="Dispositivi CLOUD FREE" testid="home-cloud-free" />
      <PromoBanners banners={home?.banners} />
      <Section eyebrow="Selezione LeonTech" title="Prodotti in evidenza" to="/catalogo" testid="home-featured">
        <ProductGrid items={featured || []} loading={!featured} testid="featured-grid" />
      </Section>
      <Advantages />
    </div>
  );
}
